import React from 'react';

// Components
import Button from './Button';

const GroupSwitch = ({ buttons, onSelect }) => {
  if (onSelect) {
    return <Button buttons={buttons} onSelect={onSelect} />;
  }

  return <Button buttons={buttons} />;
};

export default GroupSwitch;
